export const GET_USER_PAYMENTS = "GET_USER_PAYMENTS";
export const GET_USER_PAYMENTS_SUCCESS = "GET_USER_PAYMENTS_SUCCESS";
export const GET_USER_PAYMENTS_FAILED = "GET_USER_PAYMENTS_FAILED";

export const REDO_USER_PAYMENT = "REDO_USER_PAYMENT";
export const REDO_USER_PAYMENT_SUCCESS = "REDO_USER_PAUMENT_SUCCESS";
export const REDO_USER_PAYMENT_FAILED = "REDO_USER_PAYMENT_FAILED";